/**
 * Balances from one `/tangible` response (#2158, epic #2138). Since #2156 the
 * endpoint is active-only and carries every live balance: `byAccount`
 * (Checking and Credit Card), `bySavingsLedger` and `byBudget`, each row in
 * the shape of its per-entity balance endpoint. Pages read it once instead of
 * one `/balance` call per entity; archived rows, which the endpoint omits by
 * rule, keep their per-entity calls where a page still shows them.
 *
 * Pure: cents in, cents out, no React.
 *
 * @param {object|null|undefined} body  the `/tangible` response
 * @returns {{ledgers: Object<string, number>, budgets: Object<string, number>}}
 *          balanceCents by ledgerId and by budgetId
 */
export const balancesFromTangible = (body) => {
  const ledgers = {};
  const budgets = {};
  for (const row of [...(body?.byAccount || []), ...(body?.bySavingsLedger || [])]) {
    ledgers[row.ledgerId] = row.balanceCents || 0;
  }
  for (const row of body?.byBudget || []) {
    budgets[row.budgetId] = row.balanceCents || 0;
  }
  return { ledgers, budgets };
};
